const autoNgTemplateLoaderTemplate1 = require('./createCustomTemplateView.html');

import CreateCustomTemplateViewController from './createCustomTemplateViewController.js';

angular.module('shbdeployer.app').component('createCustomTemplateView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: CreateCustomTemplateViewController,
});
